import axios from 'axios';
import { BASE_SETTINGS_URL } from '../components/constants';
import { authHeaders } from '../utils/authHeaders';

// Create a new standard question
export const createSQ = async (data) => {
    const response = await axios.post(`${BASE_SETTINGS_URL}/sq/`, data, authHeaders());
    return response.data;
};

// Get all standard questions for a specific task
export const getSQByTaskId = async (taskId) => {
    const response = await axios.get(`${BASE_SETTINGS_URL}/sq/task/${taskId}`, authHeaders());
    return response.data;
};

// Update an existing standard question
export const updateSQ = async (data) => {
    const response = await axios.put(`${BASE_SETTINGS_URL}/sq/`, data, authHeaders());
    return response.data;
};

// Delete a standard question
export const deleteSQ = async (id) => {
    const response = await axios.delete(`${BASE_SETTINGS_URL}/sq/`, { data: { id }, ...authHeaders() });
    return response.data;
};

// Get all standard questions
export const getAllSQ = async () => {
    const response = await axios.get(`${BASE_SETTINGS_URL}/sq/`, authHeaders());
    return response.data;
};

export const reorderSQ = async (orderList) => {
  const response = await axios.put(`${BASE_SETTINGS_URL}/sq/reorder`, orderList, authHeaders());
  return response.data;
};
